<template>
  <div class="mb-5">
    <div class="fv-row">
      <!--begin::Label-->
      <label class="form-label">{{ label }}</label>
      <!--end::Label-->
      <!--begin::Input-->
      <!--begin::Select2-->
      <el-select
        filterable
        placeholder="Pilih"
        class="form-control p-0 el-input-no-border"
        :value="modelValue"
        v-model="choose"
        @change="updateValue"
      >
        <el-option
          v-for="item in options"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>

      <!-- <select
        class="form-select"
        data-control="select2"
        data-hide-search="true"
        data-placeholder="Select an option"
        :value="modelValue"
        @change="updateValue"
      >
        <template v-for="o in options" :key="o.value">
          <option :value="o">{{ o }}</option>
        </template>
      </select> -->
      <!--end::Select2-->
      <!--end::Input-->
      <!--begin::Description-->
      <div class="text-muted fs-7"></div>
      <!--end::Description-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: String,
    options: Array,
    label: String,
  },
  methods: {
    updateValue(value) {
      this.$emit("update:modelValue", value);
    },
  },
  data() {
    return {
      choose: "",
    };
  },
};
</script>
